import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { PageHeader } from "../../../../../components/page-header";
import { useEntityTypes } from "./useEntityTypes";
import { AddEntityTypesModal } from "./AddEntityTypesModal";
import { EntEntityTypes } from "../../../../../models/handBooks/entityTypes";
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetEntityTypesListQuery } from "../../../../../redux/api/handBooksApi/entityTypesApi";
import { useTranslation } from "react-i18next";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import _ from "lodash";
import { useForm } from "antd/es/form/Form";
import { EntEntityTypesFilter } from "../../../../../models/filters/entityTypesFilter";
import i18n from "i18next";
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  codeOrName
}

export const EntityTypes = () => {
  const [ form ] = useForm();
  const [ modal, contextHolder ] = Modal.useModal();
  const { t } = useTranslation()
  const [ selectedItem, setSelectedItem ] = useState<EntEntityTypes>(new EntEntityTypes());
  const [ showModal, setShowModal ] = useState<boolean>(false);

  const [ getArchiveFolders ] = useLazyGetEntityTypesListQuery();
  const {
	fetching,
	filter,
	data,
	access,
	totalItems,
	setData,
	setFilter,
	setCurrentPage,
	setFetching
  } = useGetDataOnScroll<EntEntityTypes, EntEntityTypesFilter>({
	initialFilter: new EntEntityTypesFilter(),
	query: getArchiveFolders
  });

  const { onAddEntityTypes, onEditEntityTypes, onDeleteEntityTypes } = useEntityTypes(modal, () => {
	searchHandleClick()
  })
  const [ height, setHeight ] = useState<number>(0);

  const openAddModal = (item: EntEntityTypes) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntEntityTypesFilter => {
	let item: EntEntityTypesFilter = _.clone(filter);
	item.codeOrName = form.getFieldValue(FormField.codeOrName) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.codeOrName, value: null },
	]);
  }


  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th style={ { width: "200px" } }>{ t('general.code') }</th>
		  <th style={ { width: "200px" } }>{ t('general.name') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
			<tr key={ item.id }>
			  <td>{ ++index }</td>
			  <td>{ item?.alias }</td>
			  <td>{ i18n.language === 'ru' ? item.nameRu : item.nameKy }</td>
			  <td>
				  <Flex gap="small">
					{ access && access.methodPut && (
					<Tooltip title={ t('general.edit') }>
					  <Button className='btn_edit' onClick={ () => {
						openAddModal(item)
					  } } type="primary" shape="circle" icon={ <EditOutlined/> }/>
					</Tooltip>
					  )}
					{ access && access.methodDelete && (
					<Tooltip title={ t('general.delete') }>
					  <Button className='btn_edit' danger onClick={ () => {
						onDeleteEntityTypes(item)
					  } } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
					</Tooltip>
					  )}
				  </Flex>
			  </td>
			</tr>
		  )) :
		  <tr>
			<td colSpan={ 4 }>
			  <EmptyData/>
			</td>
		  </tr>
		}
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.organizational_and_legal_forms') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('mechanisation.organizational_and_legal_forms.organizational_and_legal_forms_desc') } { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntEntityTypes)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 1200 }
	  />
	  <AddEntityTypesModal
		entityType={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditEntityTypes : onAddEntityTypes }
	  />
	  { contextHolder }
	</>
  )
}
